import React from "react";
import TableGrid from "../components/TableGrid";
import FrmUsuario from "../components/FrmUsuario";
import ModalPermisos from "../components/Permisos";

import { getUsuarios, deleteUser } from "../requests/req_users";
import { Col, FormGroup, Button, Collapse, Card, CardBody } from "reactstrap";
import { confirmAlert } from "react-confirm-alert"; // Import
import { notifica, call_api } from "../requests/utils";
import confirm from "reactstrap-confirm-by-jdionicio";
//dicionario
import { headers_usuarios } from "../dicionarios";

//Layout
import Main from "../Layouts/Main";

class Usuarios extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
      infoEdit: {},
      usuarios: [],
      isOpenM: false,
      userSelect: null,
    };
    this.toggle = this.toggle.bind(this);
    this.consulta = this.consulta.bind(this);
  }
  componentDidMount() {
    this.getInfo();
  }

  getInfo = async () => {
    let info_ = await getUsuarios();
    this.setState({ usuarios: info_ });
  };

  toggle(e) {
    this.setState({ isOpen: !this.state.isOpen, infoEdit: {} });
  }

  onConfig = (data) => {
    this.setState({
      isOpenM: true,
      userSelect: data,
    });
  };

  consulta() {
    const { usuarios } = this.state;
    return (
      <TableGrid
        detalle={usuarios}
        header={headers_usuarios}
        onEdit={this.editUser}
        onDelete={this.deleteUser}
        onConfig={this.onConfig}
        rowsOfpaper={10}
        cssStyles={{
          width: "90vw",
          margin: "0 auto",
        }}
      />
    );
  }

  editUser = (parameters) => {
    this.setState({ infoEdit: parameters, isOpen: true });
  };

  deleteUser = (parameters) => {
    confirmAlert({
      title: "Desactivar usuario",
      message: `¿Seguro que desea desactivar a ${parameters.fullName} el usuario perdera el acceso a la aplicación?`,
      buttons: [
        {
          label: "Si",
          onClick: () => {
            deleteUser(parameters.idUsuario);
            this.getInfo();
          },
        },
        {
          label: "No",
          onClick: () => {},
        },
      ],
    });
  };

  onSendPermisos = async (permisos) => {
    confirmAlert({
      title: "Aviso",
      message: `Se proporcionarán los accesos al usuario seleccionado, de acuerdo a la configuración realizada ¿Estas de acuerdo?`,
      buttons: [
        {
          label: "Si",
          onClick: async () => {
            let result = await call_api({
              endpoint: "System/asignarReportesUsuario",
              data: permisos,
              method: "POST",
            });
            if (result && result.code === 0) {
              this.setState({ isOpenM: false, userSelect: null }, () => {
                notifica(
                  "success",
                  "Los cambios fueron asignados correctamente",
                  "Aviso"
                );
              });
            } else if (result.code !== 0) {
              notifica("error", result.message, "Aviso");
            }
          },
        },
        {
          label: "No",
          onClick: () => {
            console.log("No");
          },
        },
      ],
    });
  };

  render() {
    const { infoEdit, isOpen, isOpenM, userSelect } = this.state;
    return (
      <Main>
        <div className="dv_Usuarios">
          {isOpenM ? null : (
            <FormGroup className="dv_UsrsFrm" row>
              <Col sm={3} md={3} lg={3}>
                <Button color="primary" onClick={(e) => this.getInfo()}>
                  Actualizar
                </Button>
              </Col>
              <Col sm={6} md={6} lg={6}>
                <h1>Usuarios</h1>
              </Col>
              <Col sm={3} md={3} lg={3}>
                <Button color="primary" onClick={(e) => this.toggle(e)}>
                  {isOpen ? "CANCELAR" : "Agregar Usuario"}
                </Button>
              </Col>
            </FormGroup>
          )}

          {isOpenM ? null : (
            <div>
              <Collapse isOpen={isOpen}>
                <Card>
                  <CardBody>
                    <FrmUsuario
                      onSubmit={() => {
                        this.setState({ isOpen: false, infoEdit: {} }, () => {
                          this.getInfo();
                        });
                      }}
                      data={infoEdit}
                    />
                  </CardBody>
                </Card>
              </Collapse>
            </div>
          )}

          {!isOpen && !isOpenM ? (
            <div id="dv_tblUsuarios"> {this.consulta()} </div>
          ) : null}
        </div>
        {isOpenM ? (
          <ModalPermisos
            isOpen={isOpenM}
            onClose={() => this.setState({ isOpenM: false })}
            infoUser={userSelect}
            onSubmit={this.onSendPermisos}
          />
        ) : null}
      </Main>
    );
  }
}
export default Usuarios;
